import http, { ResponseData } from './httpService'

export const reportSample = async (templateId: String): Promise<Map<String, any>> => {
  const { data } = await http.get<ResponseData<Map<String, any>>>('/fe/user/center/report/reportSample/' + templateId)
  return data.data
}
